const formatters = new Map<number, Intl.NumberFormat>();

export function formatMoney(amountCents: number, minimumFractionDigits = 2) {
  let formatter = formatters.get(minimumFractionDigits);
  if (!formatter) {
    formatter = new Intl.NumberFormat("en-US", {
      currency: "USD",
      maximumFractionDigits: 2,
      minimumFractionDigits,
      style: "currency",
    });
    formatters.set(minimumFractionDigits, formatter);
  }
  return formatter.format(amountCents / 100);
}
